/**
 * SegmentedControl Component - Controller
 * =========================================
 */

import type { INgModelController } from 'angular';
import { BASE_CLASSES, DEFAULTS, SegmentedControlOption } from './constants';

export interface SegmentedControlBindings {
  options?: SegmentedControlOption[];
  bg?: boolean;
  onChange?: (args: { value: string }) => void;
}

export class SegmentedControlController implements SegmentedControlBindings {
  ngModelCtrl?: INgModelController | null;

  // Bindings
  options?: SegmentedControlOption[];
  bg?: boolean;
  onChange?: (args: { value: string }) => void;

  // Estado interno
  selectedValue = '';

  $onInit(): void {
    if (this.bg === undefined || this.bg === null) {
      this.bg = DEFAULTS.bg;
    }
    this.options = this.options || [];
    if (this.ngModelCtrl) {
      // ⚠️ BRIDGE (leer) — value-based: viewValue === value seleccionado.
      this.ngModelCtrl.$render = () => {
        this.selectedValue = (this.ngModelCtrl && (this.ngModelCtrl.$viewValue as string)) || '';
      };
    }
  }

  $onDestroy(): void {
    this.ngModelCtrl = null;
  }

  handleSelect(value: string): void {
    this.selectedValue = value;
    // ⚠️ BRIDGE (escribir) — value-based: setViewValue(value).
    if (this.ngModelCtrl) {
      this.ngModelCtrl.$setViewValue(value);
    }
    if (typeof this.onChange === 'function') {
      this.onChange({ value });
    }
  }

  // ---- Clases ----

  getContainerClasses(): string[] {
    return [BASE_CLASSES.container, this.bg ? BASE_CLASSES.containerBg : BASE_CLASSES.containerPlain];
  }

  getOptionClasses(option: SegmentedControlOption): string[] {
    const radius = this.bg ? BASE_CLASSES.optionRadiusBg : BASE_CLASSES.optionRadiusPlain;
    const isSelected = option.value === this.selectedValue;
    if (!isSelected) {
      return [BASE_CLASSES.option, radius, BASE_CLASSES.unselected];
    }
    return [BASE_CLASSES.option, radius, this.bg ? BASE_CLASSES.selectedOnBg : BASE_CLASSES.selectedPlain];
  }
}

export default SegmentedControlController;
